import React, { Component } from 'react';
import Image from './react-picture';
import isFunction from "lodash/isFunction";
import merge from "lodash/merge";
import { buildImagePath } from 'config/paths';

const defaultLink = 'https://img.peerspace.com/image/upload/c_crop,g_custom/g_auto,c_fill,q_auto:eco,f_auto,fl_progressive:steep';
export const cloudinaryLink = 'https://img.peerspace.com/image/upload/c_crop,g_custom/g_auto,c_fill,q_auto,f_auto,fl_progressive:steep';

export default class ListingImage extends Component {
  constructor (props) {
    super(props);

    this.imageHasLoaded = this.imageHasLoaded.bind(this);
    this.populateImageURL = this.populateImageURL.bind(this);
    this.srcSet = this.srcSet.bind(this);
    this.renderImage = this.renderImage.bind(this);
  }

  imageHasLoaded () {
    this.props.onPicLoad();
  }

  populateImageURL (imgId, width, height, addTransform) {
    const dpr = this.props.dpr;
    const img = imgId
      ? `${cloudinaryLink},dpr_${ dpr || 2.0 },w_${width},h_${height}/${addTransform ? addTransform : ''}${imgId}`
      : buildImagePath('listing-placeholder.svg?v=rb');

    return img;
  }

  srcSet (id) {
    const { height, widths, addTransform } = this.props;

    return widths.map(width => {
      let calcHeight = (height ? height : (width / this.props.ratio)).toFixed(0);

      return `${this.populateImageURL(id, width, calcHeight, addTransform)} ${width}w`;
    }).toString();
  }

  renderImage () {
    const { alt, defaultWidth, defaultHeight, imgId, sizes, style, id, onPicLoad } = this.props;
    const imgs = this.srcSet(imgId);
    const picLoadCB = () => {
      this.imageHasLoaded();
    };

    let extraSettings = {
      className: style,
      sizes,
      src: imgId ? `${defaultLink},w_${defaultWidth},h_${defaultHeight}/${imgId}` : buildImagePath('listing-placeholder.svg?v=rb'),
      itemProp: 'image',
      id
    };

    if (isFunction(onPicLoad)) {
      merge(extraSettings, { onLoad: picLoadCB });
    }

    return <Image alt={ alt } srcSet={ imgs } extra={ extraSettings } />;
  }

  render () {
    const { containerStyle } = this.props;

    return (
      <div className={ containerStyle || '' }>
        { this.renderImage() }
      </div>
    );
  }
}
